import { limit, orderBy, query } from 'firebase/firestore'
import { ArrayService } from './serviceLive'
import type { Stock } from '~/models/MedicationAgreement/Stock'

export class StockService extends ArrayService<Stock> {
  private _collection

  constructor() {
    super('MedicationAgreement', { collectionGroupName: 'Stock' })
    const { collection } = useFirebase()
    this._collection = collection
  }

  public listenForStocksByMedicationAgreementIds(
    medicationAgreementIds: string[],
  ): void {
    const listenQueries = medicationAgreementIds.map(medicationAgreementId =>
      this.buildQuery(medicationAgreementId),
    )

    this.listenGroup(listenQueries)
  }

  private buildQuery(medicationAgreementId: string) {
    return query(
      this._collection(`MedicationAgreement/${medicationAgreementId}/Stock`),
      orderBy('Created', 'desc'),
      limit(1),
    )
  }
}
